import { action, makeObservable, observable, reaction } from 'mobx';
import { RISK_TYPES, SECTORS_DEG, SECTORS_TYPES } from '../wheelCore/constants';
import { wheelGameService } from '../wheelService/gameService';
import { checkHashStore } from '../../../store/checkHashStore';
import { isMobile } from '../../../core/helpers/isMobile';
import { userInfoStore } from '../../../store/userInfoStore';
import { freeBetStore } from '../../../store/freeBetStore';

class WheelBetsStore {
  sector = SECTORS_TYPES[2];

  oddsDic = null;

  winAmount = 0;

  winOddAndAmount = {
    winAmount: null,
    winOdd: null,
  };

  lastResults = [];

  riskType = RISK_TYPES[1].type;

  isBetsClosed = false;

  isStartWheel = false;

  roundColorOdd = null;

  wheelCurrentIndex = 0;

  wheelNextIndex = null;

  roundColorType = null;

  constructor() {
    makeObservable(this, {
      sector: observable,
      oddsDic: observable,
      riskType: observable,
      winAmount: observable,
      lastResults: observable,
      isBetsClosed: observable,
      isStartWheel: observable,
      roundColorOdd: observable,
      wheelNextIndex: observable,
      roundColorType: observable,
      winOddAndAmount: observable.deep,
      wheelCurrentIndex: observable,
      endWheel: action.bound,
      setSector: action.bound,
      setOddsDic: action.bound,
      startWheel: action.bound,
      setRiskType: action.bound,
      setWinAmount: action.bound,
      resetBetStore: action.bound,
      setLastResults: action.bound,
      setIsBetsClosed: action.bound,
      setRoundColorOdd: action.bound,
      setRoundColorType: action.bound,
      updateLastResults: action.bound,
      setWinOddAndAmount: action.bound,
      updateResultSaltAndKey: action.bound,
    });

    reaction(
      () => this.isBetsClosed,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  updateResultSaltAndKey({ salt, key, hash, newHash, odd, id, riskType, sectorCountType }) {
    checkHashStore.setLastRoundInfo({ salt, key, hash });
    checkHashStore.setNextRoundHash(newHash);
    checkHashStore.setLastRoundResult({ odd, id, riskType, sectorCountType });
  }

  setSector(sector) {
    this.sector = sector;
    wheelGameService.handleChangeWheelType();
  }

  setOddsDic(odds) {
    this.oddsDic = odds;
  }

  setWinOddAndAmount(value) {
    this.winOddAndAmount = value;
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setRiskType(type) {
    this.riskType = type;
    wheelGameService.handleChangeWheelType();
  }

  setLastResults(lastResults) {
    this.lastResults = lastResults.map((item, index) => ({ ...item, id: index }));
  }

  updateLastResults(lastResult) {
    const updatedLastResult = [...this.lastResults, lastResult];
    if (updatedLastResult.length > (isMobile() ? 6 : 5)) {
      updatedLastResult.splice(0, 1);
    }
    const lastEl = updatedLastResult.pop();
    this.setLastResults(updatedLastResult);
    setTimeout(() => {
      this.setLastResults([...updatedLastResult, lastEl]);
    }, 0);
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  setRoundColorOdd(odd) {
    this.roundColorOdd = odd;
  }

  setRoundColorType(type) {
    this.roundColorType = type;
  }

  startWheel(nextIndex, sector) {
    this.wheelNextIndex = nextIndex;
    this.isStartWheel = true;
    document.documentElement.style.setProperty('--sectorDeg', `-${SECTORS_DEG[sector]}deg`);
    document.documentElement.style.setProperty('--wheelNextIndex', `${nextIndex}`);
  }

  endWheel(nextIndex) {
    this.wheelCurrentIndex = nextIndex;
    this.isStartWheel = false;
    document.documentElement.style.setProperty('--wheelCurrentIndex', `${nextIndex}`);
  }

  resetBetStore() {
    this.riskType = RISK_TYPES[1].type;
    // eslint-disable-next-line prefer-destructuring
    this.sector = SECTORS_TYPES[2];
    this.isBetsClosed = false;
    this.isStartWheel = false;
    this.wheelCurrentIndex = 0;
    this.wheelNextIndex = null;
  }
}

export const wheelBetsStore = new WheelBetsStore();
